import {API_ENDPOINT as baseUrl} from "../../config";
import {
  authRequest, 
  makeRequest, 
  buildAuthGetPayload,
  buildAuthPutPayload,
  authRequestNoJSON
  } from "./AuthJSONApi";
import {normalize, schema} from "normalizr";
import {itemComposedId} from "../AvailabilityHelper";
import {Map} from "immutable";

const availability = new schema.Entity("availability", undefined, {
  idAttribute: value => itemComposedId(value)
});
const responseSchemaAvailability = { availability: new schema.Array(availability) }

const courier = new schema.Entity("courier");
const responseSchemaCouriers = { couriers: new schema.Array(courier) }


export function getAvailability() {
  const url = `${baseUrl}/shipping/availability`;
  return authRequest(token => {
    const info = buildAuthGetPayload(token);
    return makeRequest(url, info)
      .then(({response, error}) => {
        return {
          response: normalize(response, responseSchemaAvailability),
          error: error
        }
      })
  })
}

export function getCouriers() {
  const url = `${baseUrl}/shipping/couriers`;
  return authRequest(token => {
    const info = buildAuthGetPayload(token);
    return makeRequest(url, info)
      .then(({response, error}) => {
        return {
          response: normalize(response, responseSchemaCouriers),
          error: error
        }
      })
  })
}

export function assignWarehouseCourier(data) {
  const warehouse_id = data.get("id");
  const url = `${baseUrl}/warehouses/${warehouse_id}/courier`;
  return authRequest(token => {
    const info = buildAuthPutPayload(token, {
      courier: {
        courier_id: data.get("courier_id"),
        account_nr: data.get("account_nr")
      }
    });
    return makeRequest(url, info);
  })
}



export function getAvailabilityForCountry(data) {
  const url = `${baseUrl}/shipping/availability/country/${data.get("country")}`;
  return authRequest(token => {
    const info = buildAuthGetPayload(token);
    return makeRequest(url, info)
      .then(({response, error}) => {
        return {
          response: normalize(response, availability),
          error: error
        }
      })
  })  
}

export function getAvailabilityForUSState(data) {
  const url = `${baseUrl}/shipping/availability/us_state/${data.get("state")}`;
  return authRequest(token => {
    const info = buildAuthGetPayload(token);
    return makeRequest(url, info)
      .then(({response, error}) => {
        return {
          response: normalize(response, availability),
          error: error
        }
      })
  })  
}

export function assignWarehouseToLocation(data) {
  if (data.get("kind") === "us-state") {
    return assignWarehouseToUSState(data);
  }
  return assignWarehouseToCountry(data);
}

function assignWarehouseToUSState(data) {
  const url = `${baseUrl}/shipping/availability/us_state/${data.get("code")}/assign_warehouse`;
  const payload = {
    warehouse_id: data.get("warehouse_id")
  }
  return makePutRequest(url, payload);
}

function assignWarehouseToCountry(data) {
  const url = `${baseUrl}/shipping/availability/country/${data.get("code")}/assign_warehouse`;
  const payload = {
    warehouse_id: data.get("warehouse_id")
  }
  return makePutRequest(url, payload);
}


export function setAvailability(data) {
  if (data.get("kind") === "us-state") {
    return setAvailabilityForUSState(data);
  }
  return setAvailabilityForCountry(data);
}

function setAvailabilityForCountry(data) {
  const url = `${baseUrl}/shipping/availability/country`;
  const payload = {
    country: data.get("code"),
    availability: data.get("availability")
  }
  return makePutRequest(url, payload);
}

function setAvailabilityForUSState(data) {
  const url = `${baseUrl}/shipping/availability/us_state`;
  const payload = {
    state: data.get("code"),
    availability: data.get("availability")    
  }
  return makePutRequest(url, payload);
}

function makePutRequest(url, payload) {
  return authRequest(token => {
    return makeRequest(url, buildAuthPutPayload(token, payload));
  })  
}

export function createBreakageReport(params = new Map()) {
  const url = `${baseUrl}/shipping/breakage-report?${params.toString()}`;
  return authRequestNoJSON(token => {
    const info = buildAuthGetPayload(token);
    return fetch(url, info);
  })
}